// CORE IMPORTS
import { Box } from "@mui/material";

// COMPONENTS
import { LoadingSpinner } from "src/components/application/LoadingSpinner";
import { ValueText, MaxButton } from "../../styles/Trade.styles";

interface IPriceDisplayProps {
  priceText: string;
  backgroundColor?: string;
  buttonText: string;
  buttonDisabled: boolean;
  isLoading?: boolean;
  onButtonClick: () => void;
}
export const PriceDisplay = ({
  priceText,
  backgroundColor = "#F8F9F9",
  buttonText,
  buttonDisabled,
  isLoading = false,
  onButtonClick,
}: IPriceDisplayProps): JSX.Element => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      padding="8px"
      sx={{
        borderRadius: "8px",
        backgroundColor,
        gap: "12px",
      }}>
      <ValueText color="#5C6469" xsFontSize="11px">
        {priceText}
      </ValueText>
      {isLoading && <LoadingSpinner size={16} color="#09BF81" />}
      <MaxButton disabled={buttonDisabled} onClick={onButtonClick}>
        {buttonText}
      </MaxButton>
    </Box>
  );
};
